module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAQhJREFUWEftV8ENgzAMJJvQTegmdAngB/yAJcom7SZlk9QnGalFjpsgUD/mmVzs84VIdy4LfFVVtc65krbzECZyffHez9M09RLeSYvcvItsEAUjEp1EQiRQ1/WLJ5/HcbxFdRBATdPk1LilLSi5UK3LFhYi4AGkA+J+CiEmgYHEekbAFDAFTAFTwBQwBUwBU0BVgFzxNcV+BbDwhfddluyA5l8lJI+pKvB3Ake4YgxBNh9XUCYr8IsALDfywzAMT02tUwh8+v1Q6llJnUWgoMYPbqImqD0EULjAM9Tk5QyZE64n3BK6hjXqRf8DJG/JbxdF1fuNeCnIhVlSOMUBnq6AEhFNNIgaz9/0l1ow3GIaiwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone.png
// module id = JhOT
// module chunks = 110